import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 175px;

  @media (max-width: 1199px) {
    padding: 0;
  }

  @media (max-width: 991.98px) {
    max-width: 100%;
    margin: 0px auto;
    padding-left: 30px;
    padding-right: 30px;
  }

  @media (max-width: 575px) {
    padding-left: 15px;
    padding-right: 15px;
    display: flex;
    flex-wrap: wrap;
  }
`;
export default Container;
